module.exports = __webpack_public_path__ + "static/media/stripe_unionpay.8a10aefc.svg";